module.exports = __webpack_public_path__ + "assets/ac9b6a915af09b97dfbb65f1a5ec2dc4.png";